/* src/pages/RootRedirect.jsx
 * App root: logged-in users go to the console; logged-out users go to the
 * marketing site at gocta.ai (replaces the retired in-app Home.jsx landing).
 */

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const MARKETING_URL = 'https://gocta.ai';

export default function RootRedirect() {
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser) {
      window.location.replace(MARKETING_URL);
    }
  }, [currentUser]);

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 24, textAlign: 'center' }}>
      <p style={{ color: '#333', fontSize: 16 }}>
        Redirecting to <a href={MARKETING_URL}>{MARKETING_URL}</a>...
      </p>
    </div>
  );
}
